import { useCallback, useState, useEffect } from 'react';
import { NativeBiometric } from '@capgo/capacitor-native-biometric';
import { platform } from '@/lib/platform';

export function useBiometricAuth() {
  const [isAvailable, setIsAvailable] = useState(false);
  const [biometryType, setBiometryType] = useState<string>('');

  useEffect(() => {
    if (!platform.isNative) return;
    NativeBiometric.isAvailable().then(result => {
      setIsAvailable(result.isAvailable);
      setBiometryType(result.biometryType?.toString() || '');
    }).catch(() => setIsAvailable(false));
  }, []);

  const storeCredentials = useCallback(async (email: string, refreshToken: string) => {
    if (!platform.isNative || !isAvailable) return;
    await NativeBiometric.setCredentials({
      username: email,
      password: refreshToken, // Store refresh token, not password
      server: 'com.glorifyllc.forge',
    });
  }, [isAvailable]);

  const authenticate = useCallback(async () => {
    if (!platform.isNative || !isAvailable) return null;

    const verified = await NativeBiometric.verifyIdentity({
      reason: 'Unlock Forge',
      title: 'Biometric Login',
    }).then(() => true).catch(() => false);

    if (!verified) return null;

    const credentials = await NativeBiometric.getCredentials({
      server: 'com.glorifyllc.forge',
    });

    return credentials; // { username, password (refresh token) }
  }, [isAvailable]);

  const clearCredentials = useCallback(async () => {
    if (!platform.isNative) return;
    await NativeBiometric.deleteCredentials({
      server: 'com.glorifyllc.forge',
    }).catch(() => {});
  }, []);

  return { isAvailable, biometryType, storeCredentials, authenticate, clearCredentials };
}
